const MileStoneType = {
    // add milstones
    ADD_ALL_MILESTONES: "ADD_ALL_MILESTONES",
    ADD_ALL_MILESTONES_LOADING: "ADD_ALL_MILESTONES_LOADING",
    ADD_ALL_MILESTONES_SUCCESS: "ADD_ALL_MILESTONES_SUCCESS",
    ADD_ALL_MILESTONES_RESET: "ADD_ALL_MILESTONES_RESET",
    ADD_ALL_MILESTONES_ERROR: "ADD_ALL_MILESTONES_ERROR",

    // get milstones
    GET_ALL_MILESTONES: "GET_ALL_MILESTONES",
    GET_ALL_MILESTONES_LOADING: "GET_ALL_MILESTONES_LOADING",
    GET_ALL_MILESTONES_SUCCESS: "GET_ALL_MILESTONES_SUCCESS",
    GET_ALL_MILESTONES_RESET: "GET_ALL_MILESTONES_RESET",
    GET_ALL_MILESTONES_ERROR: "GET_ALL_MILESTONES_ERROR",


    // delete project

    DELETE_MILE_STONE: "DELETE_MILE_STONE",
    DELETE_MILE_STONE_LOADING: "DELETE_MILE_STONE_LOADING",
    DELETE_MILE_STONE_SUCCESS: "DELETE_MILE_STONE_SUCCESS",
    DELETE_MILE_STONE_ERROR: "DELETE_MILE_STONE_ERROR",
    DELETE_MILE_STONE_RESET: "DELETE_MILE_STONE_RESET",
    // get milestone by id
    GET_ALL_MILESTONE_BY_ID: " GET_ALL_MILESTONE_BY_ID",
    GET_ALL_MILESTONE_BY_ID_LOADING: " GET_ALL_MILESTONE_BY_ID_LOADING",
    GET_ALL_MILESTONE_BY_ID_SUCCESS: " GET_ALL_MILESTONE_BY_ID_SUCCESS",
    GET_ALL_MILESTONE_BY_ID_RESET: " GET_ALL_MILESTONE_BY_ID_RESET",
    GET_ALL_MILESTONE_BY_ID_ERROR: " GET_ALL_MILESTONE_BY_ID_ERROR",

    // update milestone
    UPDATE_MILESTONE: " UPDATE_MILESTONE",
    UPDATE_MILESTONE_LOADING: " UPDATE_MILESTONE_LOADING",
    UPDATE_MILESTONE_SUCCESS: " UPDATE_MILESTONE_SUCCESS",
    UPDATE_MILESTONE_RESET: " UPDATE_MILESTONE_RESET",
    UPDATE_MILESTONE_ERROR: " UPDATE_MILESTONE_ERROR",
    // get milestone 
    
    GET_SINGLE_MILESTONE: " GET_SINGLE_MILESTONE",
    GET_SINGLE_MILESTONE_LOADING: " GET_SINGLE_MILESTONE_LOADING",
    GET_SINGLE_MILESTONE_SUCCESS: " GET_SINGLE_MILESTONE_SUCCESS",
    GET_SINGLE_MILESTONE_RESET: " GET_SINGLE_MILESTONE_RESET",
    GET_SINGLE_MILESTONE_ERROR: " GET_SINGLE_MILESTONE_ERROR",

    GET_MILESTONE_FOR_TASK: " GET_MILESTONE_FOR_TASK",
    GET_MILESTONE_FOR_TASK_LOADING: " GET_MILESTONE_FOR_TASK_LOADING",
    GET_MILESTONE_FOR_TASK_SUCCESS: " GET_MILESTONE_FOR_TASK_SUCCESS",
    GET_MILESTONE_FOR_TASK_RESET: " GET_MILESTONE_FOR_TASK_RESET",
    GET_MILESTONE_FOR_TASK_ERROR: " GET_MILESTONE_FOR_TASK_ERROR",

    GET_PROJECT_TASKS: " GET_PROJECT_TASKS",
    GET_PROJECT_TASKS_LOADING: " GET_PROJECT_TASKS_LOADING",
    GET_PROJECT_TASKS_SUCCESS: " GET_PROJECT_TASKS_SUCCESS",
    GET_PROJECT_TASKS_RESET: " GET_PROJECT_TASKS_RESET",
    GET_PROJECT_TASKS_ERROR: " GET_PROJECT_TASKS_ERROR",

};

export default MileStoneType;
